export default "__VITE_ASSET__CAX4UBcm__"